import { css } from '@emotion/react';
import { colors, fonts } from '../../styles/theme';

export const primary = css`
  border-color: ${colors.blue.primaryDark};
  background-color: ${colors.blue.primary};
  color: ${colors.white};
  &:hover {
    background-color: ${colors.blue.primaryLight};
  }
`;

export const secondary = css`
  border-color: ${colors.blue.secondaryDark};
  background-color: ${colors.blue.secondary};
  color: ${colors.blue.primary};
  &:hover {
    background-color: ${colors.blue.secondaryLight};
  }
`;

export const transparent = css`
  color: ${colors.blue.primary};
  &:hover {
    text-decoration: underline;
  }
`;

export const disabled = css`
  transition: none;
  cursor: not-allowed;
  background: ${colors.grey.secondaryDark} !important;
  border-color: ${colors.grey.secondaryDark};
  color: ${colors.grey.secondaryLight};
`;

export const small = css`
  font-size: ${fonts.sans.size.small};
  line-height: 28px;
  height: 30px;
  padding: 0 9px;
`;

export const medium = css`
  line-height: 38px;
  height: 40px;
  padding: 0 12px;
`;

const buttonVariants = {
  secondary,
  primary,
  transparent,
  small,
  medium,
  disabled,
};

export const buttonStyles = (props) => {
  return css`
    align-items: center;
    appearance: none;
    background: none;
    border-radius: 3px;
    border: 1px solid transparent;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    font-family: ${fonts.sans.family};
    font-size: ${fonts.sans.size.normal};
    font-weight: ${fonts.sans.weight.bold};
    justify-content: center;
    outline: none;
    text-align: center;
    text-decoration: none;
    text-transform: ${props.textTransform};
    transition: all 0.3s ease;
    vertical-align: top;
    white-space: nowrap;
    width: auto;
    letter-spacing: 0.03em;
    & + button {
      margin-left: 5px;
    }

    ${buttonVariants[props.size]};
    ${buttonVariants[props.variant]};

    &:disabled,
    &:disabled:hover,
    &:disabled:focus {
      transition: none;
      cursor: not-allowed;
      background: ${colors.grey.secondaryDark} !important;
      border-color: ${colors.grey.secondaryDark};
      color: ${colors.grey.secondaryLight};
      text-decoration: none;
    }
  `;
};
